import { useMemo } from 'react'
import { EVM_DEFAULT_BASES, type EvmChainId, isEvmChainId } from 'sushi/evm'

interface UseChipTokens<TChainId extends EvmChainId> {
  chainId: TChainId
  includeNative?: boolean
  showPinnedTokens?: boolean
}

// TODO: Add pinned tokens

export function useChipTokens<TChainId extends EvmChainId>({
  chainId,
  includeNative = true,
  // showPinnedTokens = true,
}: UseChipTokens<TChainId>) {
  const defaultBases = useMemo(() => {
    if (isEvmChainId(chainId)) {
      return EVM_DEFAULT_BASES[chainId]
    }

    throw new Error('Unsupported chainId')
  }, [chainId])

  // const {} = usePinnedTokens()

  return useMemo(() => {
    return defaultBases.flatMap((base) => {
      if (base.type === 'native' && !includeNative) return []

      return {
        default: true,
        token: base as CurrencyFor<TChainId>,
      }
    })
  }, [includeNative, defaultBases])
}
